module.exports = __webpack_public_path__ + "static/media/vmove-logo-2.3cacdbad.svg";